module.exports={select:"Auswählen",selected:"Ausgewählt"};